import { Button } from 'antd'
import { useContext, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalculator } from '@fortawesome/pro-solid-svg-icons'
import { AuthenticationContext } from '../../../AuthenticationContext'
import ItemCalculationsDrawer from './ItemCalculationsDrawer'

const SuperUserItemCalculations = () => {
  const { currentUser } = useContext(AuthenticationContext)
  const [open, setOpen] = useState(false)

  if (currentUser?.isSuperUser !== true) {
    return null
  }

  return <>
    <Button icon={<FontAwesomeIcon icon={faCalculator} />} onClick={() => setOpen(true)}>
      Item Calculation details
    </Button>
    <ItemCalculationsDrawer open={open} onClose={() => setOpen(false)} />
  </>
}

export default SuperUserItemCalculations
